<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    :top="transferStableCoins ? '15vh' : '30vh'"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="-mt-10">
      <p class="font-medium text-sm lg:text-base text-fg-default">
        Select a {{ currencyType }} currency
      </p>
      <!-- search -->
      <div class="mt-6 border-main rounded-lg px-2">
        <el-select
          class="w-full"
          filterable
          remote
          v-model="search"
          placeholder="Search"
          :remote-method="remoteMethod"
          :loading="isLoading"
        >
          <el-option
            v-for="(country, index) in options"
            :key="index"
            :label="country.name"
            :value="country.name"
          >
            {{ country.name }}</el-option
          >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-select>
      </div>
      <!-- Fiat Currencies -->
      <div>
        <p class="text-root-1 mt-5 font-medium">Fiat Currencies</p>
        <ul class="my-4">
          <li
            v-for="currency in filteredFiatCurrencies"
            :key="currency.currency"
            class="flex mb-2 cursor-pointer gap-x-4 px-4 py-2 hover:bg-gray-1"
            :class="[
              {},
              {
                'cursor-not-allowed fg-disabled p-1 rounded-lg':
                  !isTransferable(currency.currency)
              }
            ]"
            v-on="
              isTransferable(currency.currency)
                ? { click: () => setCurrency(currency.currency) }
                : {}
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              :disabled="isTransferable(currency.currency)"
              :content="getTransferDetail(currency.currency)"
              placement="right"
            >
              <div class="flex items-center gap-x-4">
                <currency-icon
                  :currency="currency.name"
                  size="lg:h-8 lg:w-8 h-6 w-6"
                />
                <span class="font-light">{{
                  `${currency.currency} - ${currency.currencyFull}`
                }}</span>
              </div>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <!-- Stable Coins -->
      <div v-if="transferStableCoins">
        <p class="text-root-1 mt-5 font-medium">Stable Coins</p>
        <ul class="my-5">
          <li
            v-for="currency in stableCoins"
            :key="currency.currency"
            class="flex gap-x-4 px-4 py-2 mb-2 hover:bg-gray-1 cursor-pointer"
            :class="[
              {
                'cursor-not-allowed fg-disabled p-1 rounded-lg':
                  !isTransferable(currency.currency, 'asset')
              }
            ]"
            v-on="
              isTransferable(currency.currency, 'asset')
                ? { click: () => setCurrency(currency.currency) }
                : {}
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              visible-arrow="true"
              :disabled="isTransferable(currency.currency, 'asset')"
              :content="getTransferDetail(currency.currency, 'asset')"
              placement="right"
            >
              <div class="flex items-center gap-x-4">
                <currency-icon
                  :currency="currency.name"
                  size="lg:h-8 lg:w-8 h-6 w-6"
                />
                <span class="font-light">{{ currency.currencyFull }}</span>
              </div>
            </el-tooltip>
          </li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import { COUNTRIES, FIAT, STABLE_COINS } from '@/utils/constants'
import country from '@/mixins/getCountryDetails.js'
import transferInfoDetails from '@/mixins/localDeposit.js'
import getTransferDetail from '@/mixins/terminal.js'
export default {
  mixins: [country, transferInfoDetails, getTransferDetail],
  components: {
    CurrencyIcon: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  name: 'SelectCurrency',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    currencyType: {
      type: String,
      default: ''
    },
    inputEmpty: {
      type: Boolean
    }
  },
  data () {
    return {
      breakpoints,
      allCountries: COUNTRIES,
      isLoading: false,
      currency: '',
      options: [],
      search: ''
    }
  },
  computed: {
    filteredFiatCurrencies () {
      if (this.search) {
        return FIAT.filter(
          (fiat) =>
            fiat.name.includes(this.search.toLowerCase()) ||
            fiat.currency.toLowerCase().includes(this.search.toLowerCase())
        )
      } else {
        return FIAT
      }
    },
    stableCoins () {
      if (this.search) {
        return STABLE_COINS.filter((coin) =>
          coin.name.includes(
            this.search.toLowerCase() ||
              coin.currency.toLowerCase().includes(this.search.toLowerCase())
          )
        )
      } else {
        return STABLE_COINS
      }
    },
    transferStableCoins () {
      return process.env.VUE_APP_TRANSFER_STABLE_COINS === 'true'
    },
    hasBeenDebited () {
      return this.$store.state.terminal.hasBeenDebited
    },
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items || []
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '28%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isSourceCurrency () {
      return this.currencyType === 'source'
    },
    isFirstTimeOnSelect () {
      return this.inputEmpty
    }
  },

  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.allCountries.filter((item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 100)
      } else {
        this.options = []
      }
    }
  }
}
</script>

<style scoped>
button {
  border-radius: 200px;
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
>>> .el-select {
  width: 100%;
}

>>> .el-input__prefix {
  left: 1px;
}
>>> .el-input__inner {
  font-size: 0.8rem;
  font-weight: 400;
}
@media screen and (min-width: 1280px) {
  >>> .el-dialog {
    margin-right: 28.5vw;
  }
}
@media screen and (min-width: 1680px) {
  >>> .el-dialog {
    margin-right: 31.5vw;
  }
}
</style>
